import { useAuthStore } from 'src/stores/auth'

export const guestGuard = () => {
  const auth = useAuthStore()

  if (auth.isLoggedIn) {
    return { name: 'home' }
  }

  return true
}
